import { useEffect, useState, type ComponentType, type JSX } from "react";

type DevtoolsComponent = ComponentType<{ initialIsOpen?: boolean }>;

export function DevQueryTools(): JSX.Element | null {
  const [Devtools, setDevtools] = useState<DevtoolsComponent | null>(null);

  useEffect(() => {
    if (!import.meta.env.DEV) return;

    let active = true;
    void import("@tanstack/react-query-devtools")
      .then(({ ReactQueryDevtools }) => {
        if (active) setDevtools(() => ReactQueryDevtools);
      })
      .catch(() => {
        // 開発用診断が読み込めなくてもアプリ本体の起動は継続する。
      });

    return () => {
      active = false;
    };
  }, []);

  if (!import.meta.env.DEV || Devtools === null) return null;
  return <Devtools initialIsOpen={false} />;
}
